import { ResponseTypes } from "../constants/enum.tsx";
import { toast } from "react-toastify";
import {
  ApiType,
  BaseUrls,
  ContentTypes,
  ResponseType,
  ServiceType,
} from "../constants/baseUrls.tsx";
import Toast, { ToastType, toastHeadingMapper } from "../components/Toast.tsx";
import React from "react";

const UNHANLED_ERROR = "Something went wrong";

export const showToast = (message, type = ToastType.ERROR) => {
  toast(
    <Toast
      type={type || ToastType.ERROR}
      heading={toastHeadingMapper[type || ToastType.ERROR]}
      description={message || UNHANLED_ERROR}
    />,
    {
      autoClose: 3000,
      hideProgressBar: true,
      position: "bottom-right",
      theme: "dark",
    }
  );
};

const getErrorMessage = (responseData: any) =>
  `${responseData?.message || UNHANLED_ERROR}${
    responseData?.data?.description || ""
  }`;

export const handleApiResponse = async (
  response: Response,
  responseType: string,
  showSuccessMessage?: boolean
) => {
  try {
    let responseData;
    if (responseType === ResponseType.BLOB) {
      responseData = await response.blob();
    } else {
      responseData = await response.json();
      if (
        !responseData ||
        responseData?.status === ResponseTypes.FAILURE ||
        response.status >= 300
      ) {
        const errorMessage = getErrorMessage(responseData);
        showToast(errorMessage);
        return {};
      } else if (
        responseData?.status === ResponseTypes.SUCCESS &&
        showSuccessMessage
      ) {
        showToast(responseData?.message || "Success", ToastType.SUCCESS);
      }
    }
    //dispatch(appActions.setLoader(false));
    return responseData;
  } catch (err) {
    if (response.status === 200) {
      return response;
    } else {
      showToast(err?.toString() || UNHANLED_ERROR);
      //dispatch(appActions.setLoader(false));
      return {};
    }
  }
};

export const getFinalUrl = (url: string, service?: ServiceType) =>
  `${BaseUrls[service || ServiceType.DASHBOARD]}/${url}`;

export const postApi = async (
  url: string,
  data?: any,
  service?: ServiceType,
  contentType?: string,
  responseType?: string,
  blockToken?: boolean,
  showSuccessMessage?: boolean | undefined
) => {
  const response = await callFetchApi(
    ApiType.POST,
    getFinalUrl(url, service),
    data,
    contentType,
    responseType,
    blockToken,
    showSuccessMessage
  );
  return response;
};

export const putApi = async (
  url: string,
  data: any,
  service?: ServiceType,
  contentType?: string,
  responseType?: string,
  blockToken?: boolean,
  showSuccessMessage?: boolean | undefined
) => {
  const response = await callFetchApi(
    ApiType.PUT,
    getFinalUrl(url, service),
    data,
    contentType,
    responseType,
    blockToken,
    showSuccessMessage
  );
  return response;
};

export const deleteApi = async (
  url: string,
  data: any,
  service?: ServiceType
) => {
  const response = await callFetchApi(
    ApiType.DELETE,
    getFinalUrl(url, service),
    data
  );
  return response;
};

export const getApi = async (
  url: string,
  service?: ServiceType,
  showLoader = true
) => {
  const response = await callFetchApi(
    ApiType.GET,
    getFinalUrl(url, service),
    {},
    undefined,
    undefined,
    undefined,
    undefined,
    showLoader
  );
  return response;
};

export const callFetchApi = async (
  method: ApiType,
  url: string,
  data: any,
  contentType?: string,
  responseType?: string,
  blockToken?: boolean,
  showSuccessMessage?: boolean,
  showLoader?: boolean
) => {
  const options: RequestInit = {
    method,
    headers: {
      "Content-type": contentType || ContentTypes.JSON,
    },
  };
  let requestData: ArrayBuffer | string = JSON.stringify(data);
  data instanceof ArrayBuffer && (requestData = data);
  method !== ApiType.GET && (options.body = requestData);
  try {
    //if (showLoader !== false) dispatch(appActions.setLoader(true));
    const response: Response = await fetch(url, options);
    return await handleApiResponse(
      response,
      responseType || ResponseType.JSON,
      showSuccessMessage !== undefined
        ? showSuccessMessage
        : method !== ApiType.GET
    );
  } catch (error) {
    // dispatch(appActions.setLoader(false));
    showToast(error?.toString() || UNHANLED_ERROR);
    return {};
  }
};
